import * as React from 'react'

export function Footer() {
  return (
    <footer v-if="needFooter" className="max-w-6xl mx-auto my-6 border-t lg:px-12 md:px-8 sm:px-6 px-4 pt-6 space-y-1 text-gray-500 text-sm text-center">
      <p>&copy;2021-{new Date().getFullYear()} TeaCon 执行委员会</p>
      <p><a href="https://beian.miit.gov.cn/" target="_blank" className="hover:text-green-500">闽ICP备20015816号</a></p>
      <p><em>非 Minecraft 官方产品。未获 Mojang 许可，亦与 Mojang 无任何关联。</em></p>
      <p><em>NOT OFFICIAL MINECRAFT PRODUCT. NOT APPROVED BY OR ASSOCIATED WITH MOJANG.</em></p>
    </footer>
  )
}
